let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2hZlB")).then(() => parcelRequire('6Gkc6'));